







































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ModalRegraDeCalculoIncluirProcedimentoDescartar extends Vue {
  $refs!: { formProcedimentoDescartar: any }

  get getRegrasDeCalculoStore() {
    return getModule(RegrasDeCalculoStore, this.$store)
  }

  formProcedimentoDescartarRules: any = {
    valid: true,
    codigoProcedimento: [(v: any) => !!v || 'Campo obrigatório'],
    descricaoProcedimento: [(v: any) => !!v || 'Campo obrigatório'],
  }

  loadPostRegraCalculoProcedimentoDescartar: boolean = false
  get loadingPostRegraCalculoProcedimentoDescartar() { return this.loadPostRegraCalculoProcedimentoDescartar }
  set loadingPostRegraCalculoProcedimentoDescartar(value: boolean) { this.loadPostRegraCalculoProcedimentoDescartar = value }

  get showModalPostRegraCalculoProcedimentoDescartar() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoProcedimentosDescartar }
  set showModalPostRegraCalculoProcedimentoDescartar(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoProcedimentosDescartar', value }) }

  async postRegraCalculoProcedimentoDescartar() {
    if (this.$refs.formProcedimentoDescartar.validate()) {
      this.loadingPostRegraCalculoProcedimentoDescartar = true
      const request = await this.getRegrasDeCalculoStore.postRegraCalculoProcedimentoDescartar()
      if (!request.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
        this.loadingPostRegraCalculoProcedimentoDescartar = false
        return
      }
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Procedimento incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
        icon: 'done',
        color: '#2E7D32',
      })
      this.loadingPostRegraCalculoProcedimentoDescartar = false
      this.showModalPostRegraCalculoProcedimentoDescartar = false
    }
  }

  @Watch('showModalPostRegraCalculoProcedimentoDescartar')
  onChangeShowModalPostRegraCalculoProcedimentoDescartar(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.clearProcedimentoDescartar()
      this.$refs.formProcedimentoDescartar.resetValidation()
      this.$refs.formProcedimentoDescartar.reset()
    }
  }
}
